import React from 'react';
import * as MagicBell from '@magicbell/react-headless';
import { useAccount, useUser } from '~/authentication/store';

function NotificationsProvider({ children }) {
  const { loading, isLoggedIn, isHost, isAdmin } = useUser()
  const { account } = useAccount();

  if (loading || !isLoggedIn || (!isHost && !isAdmin)) {
    return children;
  }

  return (
    <MagicBell.MagicBellProvider
      apiKey={MAGIC_BELL_API_KEY}
      userExternalId={account?.id}
    >
      {children}
    </MagicBell.MagicBellProvider >
  );
}

function useNotificationsStore(category?: string) {
  return MagicBell.useNotifications(category);
}

export { NotificationsProvider, useNotificationsStore };
